<template>
  <multiselect
    class="ms-dropdown"
    v-model="selected"
    :options="optionsSingle"
    :multiple="false"
    :close-on-select="closeOnSelect"
    :clear-on-select="false"
    :preserve-search="true"
    :placeholder="formatSelectedValue(selected, charLimit)"
    label="text"
    track-by="text"
    deselectLabel="✓"
    selectedLabel="✓"
    selectLabel=""
    :disabled="disabled"
    :allowEmpty="false"
    :custom-label="(selected) => formatSelectedValue(selected, charLimit)"
  >
    <template v-slot:caret="{ toggle }">
      <div @mousedown.prevent.stop="toggle()" class="multiselect__select">
        <img :src="arrow" class="icon" />
      </div>
    </template>

    <template v-slot:noResult> No elements found. </template>
  </multiselect>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, PropType, computed } from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/styles/ms-select-styles.scss'
import arrow from '@/assets/svg/arrow.svg'

const props = defineProps({
  optionsSingle: {
    type: Array<{ value: string; text: string }>,
    required: false
  },
  modelValue: {
    type: Object as PropType<{ value: string; text: string } | null>,
    required: false
  },
  selectText: {
    type: String,
    required: false
  },
  closeOnSelect: {
    type: Boolean,
    required: false,
    default: true
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  width: {
    type: String,
    required: false,
    default: '220px'
  }
})

const emits = defineEmits(['update:modelValue'])

const selected = computed({
  get: () => getSelected(),
  set: (val) => updateSelected(val)
})

const updateSelected = (val: { value: string; text: string } | null) => {
  emits('update:modelValue', val)
}

const charLimit = computed(() => parseInt(props.width, 10) / 3)

const getSelected = () => {
  return props.modelValue
}

const formatSelectedValue = (
  selected: { value: string; text: string } | null,
  charLimit: number
) => {
  if (selected === null) {
    return props.selectText || ''
  }

  const text = selected.text

  if (text.length <= charLimit) {
    return text
  }

  return text.slice(0, charLimit - 3) + '...'
}
</script>

<style scoped lang="scss">
.multiselect__tags,
.multiselect {
  width: v-bind('width') !important;
}
</style>
